import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ReportTemplateVersion } from 'dashboard/models/report-template-version';
import { setReportTemplateVersion } from 'dashboard/redux/actions/report-template-version';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadReportTemplateVersion =
  (reportTemplateVersionId: string): DashboardThunkAction =>
  async (dispatch) => {
    const response = await SessionClientDashboard.getResource<ReportTemplateVersion>(
      ApiEndpoint.ReportTemplateVersion,
      reportTemplateVersionId,
    );
    const { data: reportTemplateVersion } = response;

    dispatch(setReportTemplateVersion(reportTemplateVersion));
  };
